import productBasedCollectionPage from "@faire/web-api--source/routes/product-based-collection/product_based_collection_token";
/**
 * Builds a product based collection page url.
 * @param productBasedCollectionToken
 * @returns page url
 */ export var getProductBasedCollectionLinkTo = function(productBasedCollectionToken) {
    return productBasedCollectionToken ? productBasedCollectionPage(productBasedCollectionToken) : "";
};
